import * as React from "react";
const SvgSpeed16X20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "black",
        viewBox: "0 0 20 20"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      d: "M.844 14h5.124v-1.248H4.156v-7.26h-1.26c-.168.84-.924 1.476-2.004 1.584v1.008H2.74v4.668H.844V14ZM12.58 5.768c-.371-.264-1.031-.456-1.811-.456-2.556 0-4.464 1.836-4.464 4.956 0 2.724 1.644 3.912 3.348 3.912 1.728 0 3.18-1.116 3.18-2.916 0-1.8-1.2-2.868-2.892-2.868-1.104 0-1.86.504-2.196 1.044.132-1.68 1.248-2.856 2.94-2.856.612 0 1.152.18 1.488.348l.408-1.164Zm-4.655 5.508c0-1.056.804-1.68 1.728-1.68.936 0 1.74.624 1.74 1.68s-.804 1.68-1.74 1.68c-.888 0-1.728-.636-1.728-1.68Zm6.393-4.344-.84.828 1.992 2.052-2.004 2.052.828.84 2.004-2.052 2.016 2.052.816-.84-2.004-2.052 2.004-2.064-.84-.816-1.992 2.04-1.98-2.04Z"
    })
  );
export default SvgSpeed16X20Px;
